import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { Play } from "lucide-react";

const TrailerPlayer = forwardRef(function TrailerPlayer({ testId = "trailer-player" }, ref) {
  const [play, setPlay] = useState(false);
  const wrapRef = useRef(null);

  useImperativeHandle(ref, () => ({
    play: () => {
      setPlay(true);
      wrapRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    },
  }));

  return (
    <div ref={wrapRef} data-testid={testId}>
      <div className="relative aspect-video overflow-hidden rounded-2xl border border-[#F59E0B]/30 bg-black shadow-[0_0_50px_rgba(225,29,72,0.25)]">
        {play ? (
          <video controls autoPlay className="h-full w-full" data-testid={`${testId}-video`}>
            <source src="/assets/trailer.mp4" type="video/mp4" />
            Your browser does not support video playback.
          </video>
        ) : (
          <button onClick={() => setPlay(true)} data-testid={`${testId}-play-button`}
            className="group relative h-full w-full" aria-label="Play the Laugh at L.A. trailer">
            <img src="/assets/brand/trailer-poster.jpg" alt="Laugh at L.A. trailer" className="h-full w-full object-cover opacity-80 transition-opacity group-hover:opacity-100" />
            <span className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-black/40">
              <span className="rounded-full bg-[#E11D48] p-5 shadow-[0_0_35px_rgba(225,29,72,0.6)] transition-transform group-hover:scale-110">
                <Play size={28} className="text-white" fill="white" />
              </span>
              <span className="font-display text-2xl tracking-widest text-white">Watch the Trailer</span>
            </span>
          </button>
        )}
      </div>
    </div>
  );
});

export default TrailerPlayer;
